<template>
  <div class="dashboard-page">

    <!-- Header -->
    <div class="page-header">
      <h1 class="page-title">Administration</h1>
      <div class="page-title-bar"></div>
      <p class="page-subtitle">Gestion du contenu et des utilisateurs</p>
    </div>

    <!-- Errors -->
    <v-container v-if="errors.length" class="pt-4 pb-0">
      <v-alert type="error" variant="tonal" closable v-for="(err, i) in errors" :key="i" class="mb-2">{{ err }}</v-alert>
    </v-container>

    <!-- Tabs -->
    <v-tabs v-model="tab" color="#E65100" class="dashboard-tabs" show-arrows>
      <v-tab value="articles">
        <v-icon size="16" class="mr-2">mdi-newspaper-variant-outline</v-icon>
        Articles
      </v-tab>
      <v-tab value="users">
        <v-icon size="16" class="mr-2">mdi-account-outline</v-icon>
        Utilisateurs
      </v-tab>
      <v-tab value="followers">
        <v-icon size="16" class="mr-2">mdi-bell-outline</v-icon>
        Followers
      </v-tab>
      <v-tab value="tirs">
        <v-icon size="16" class="mr-2">mdi-map-marker-outline</v-icon>
        Tirs
      </v-tab>
    </v-tabs>

    <v-divider></v-divider>

    <v-container class="dashboard-container">
      <v-tabs-window v-model="tab">

        <!-- Articles -->
        <v-tabs-window-item value="articles">
          <div class="section-toolbar">
            <span class="section-count">{{ articles.length }} article(s)</span>
            <v-btn :to="{ name: 'AddEvent' }" color="#E65100" variant="flat" size="small" prepend-icon="mdi-plus" rounded="lg">
              Ajouter un article
            </v-btn>
          </div>
          <v-data-table :headers="headers" :items="articles" items-per-page="10" class="data-table">
            <template v-slot:item.actions="{ item }">
              <v-icon size="18" class="action-icon mr-2" @click="editItem(item)">mdi-pencil-outline</v-icon>
              <v-icon size="18" class="action-icon delete" @click="deleteItem(item)">mdi-delete-outline</v-icon>
            </template>
          </v-data-table>
        </v-tabs-window-item>

        <!-- Users -->
        <v-tabs-window-item value="users">
          <div class="section-toolbar">
            <span class="section-count">{{ users.length }} utilisateur(s)</span>
            <div class="d-flex gap-2">
              <v-btn :to="{ name: 'AddUser' }" color="#E65100" variant="flat" size="small" prepend-icon="mdi-plus" rounded="lg">
                Ajouter
              </v-btn>
              <v-btn :to="{ name: 'AddUsersBulk' }" color="#BF360C" variant="flat" size="small" prepend-icon="mdi-upload" rounded="lg">
                Import CSV
              </v-btn>
            </div>
          </div>
          <v-data-table :headers="headersUsers" :items="users" items-per-page="10" class="data-table">
            <template v-slot:item.actions="{ item }">
              <v-icon size="18" class="action-icon mr-2" @click="editUser(item)">mdi-pencil-outline</v-icon>
              <v-icon size="18" class="action-icon delete" @click="deleteUser(item)">mdi-delete-outline</v-icon>
            </template>
          </v-data-table>
        </v-tabs-window-item>

        <!-- Followers -->
        <v-tabs-window-item value="followers">
          <div class="section-toolbar">
            <span class="section-count">{{ followers.length }} follower(s)</span>
            <v-btn :to="{ name: 'AddFollower' }" color="#E65100" variant="flat" size="small" prepend-icon="mdi-plus" rounded="lg">
              Ajouter un follower
            </v-btn>
          </div>
          <v-data-table :headers="headersFollowers" :items="followers" items-per-page="10" class="data-table">
            <template v-slot:item.actions="{ item }">
              <v-icon size="18" class="action-icon mr-2" @click="editFollower(item)">mdi-pencil-outline</v-icon>
              <v-icon size="18" class="action-icon delete" @click="deleteFollower(item)">mdi-delete-outline</v-icon>
            </template>
          </v-data-table>
        </v-tabs-window-item>

        <!-- Tirs -->
        <v-tabs-window-item value="tirs">
          <div class="section-toolbar">
            <span class="section-count">{{ tirs.length }} tir(s)</span>
          </div>
          <v-data-table :headers="hearderTirs" :items="tirs" items-per-page="10" class="data-table">
            <template v-slot:item.actions="{ item }">
              <v-icon size="18" class="action-icon mr-2" @click="editTir(item)">mdi-pencil-outline</v-icon>
              <v-icon size="18" class="action-icon delete" @click="deleteTir(item)">mdi-delete-outline</v-icon>
            </template>
          </v-data-table>
        </v-tabs-window-item>

      </v-tabs-window>
    </v-container>

    <!-- Edit Event Dialog -->
    <v-dialog v-model="dialog" max-width="540px">
      <v-card rounded="lg">
        <div class="dialog-header">
          <v-icon color="white" size="18" class="mr-2">mdi-newspaper-variant-outline</v-icon>
          Modifier l'article
        </div>
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedItem.title" label="Titre" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedItem.date" label="Date" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedItem.docpath" label="Doc" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedItem.picturepath" label="Image" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select v-model="editedItem.eventtype" :items="event_types" label="Type" variant="outlined" density="compact" :return-object="true"></v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="editedItem.description" label="Contenu" variant="outlined" density="compact" rows="3"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="close">Annuler</v-btn>
          <v-btn color="#E65100" variant="flat" rounded="lg" @click="save">Enregistrer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit User Dialog -->
    <v-dialog v-model="dialogUser" max-width="540px">
      <v-card rounded="lg">
        <div class="dialog-header">
          <v-icon color="white" size="18" class="mr-2">mdi-account-outline</v-icon>
          Modifier l'utilisateur
        </div>
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedUser.UserId" label="Identifiant" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedUser.FirstName" label="Prénom" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedUser.LastName" label="Nom" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select v-model="editedUser.Role" :items="roles" label="Rôle" variant="outlined" density="compact" :return-object="true"></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="closeUser">Annuler</v-btn>
          <v-btn color="#E65100" variant="flat" rounded="lg" @click="saveUser">Enregistrer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Follower Dialog -->
    <v-dialog v-model="dialogFollower" max-width="540px">
      <v-card rounded="lg">
        <div class="dialog-header">
          <v-icon color="white" size="18" class="mr-2">mdi-bell-outline</v-icon>
          Modifier le follower
        </div>
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedFollower.firstname" label="Prénom" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedFollower.lastname" label="Nom" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedFollower.firm" label="Société" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedFollower.mail" label="Mail" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedFollower.function" label="Fonction" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select v-model="editedFollower.followingType" :items="following_types" label="Type" variant="outlined" density="compact" :return-object="true"></v-select>
            </v-col>
            <v-col cols="12">
              <v-checkbox v-model="editedFollower.acceptNews" label="Accepte la Newsletter" color="#E65100" density="compact"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="closeFollower">Annuler</v-btn>
          <v-btn color="#E65100" variant="flat" rounded="lg" @click="saveFollower">Enregistrer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Tir Dialog -->
    <v-dialog v-model="dialogTir" max-width="540px">
      <v-card rounded="lg">
        <div class="dialog-header">
          <v-icon color="white" size="18" class="mr-2">mdi-map-marker-outline</v-icon>
          Modifier le tir
        </div>
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedTir.name" label="Nom" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedTir.address" label="Adresse" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedTir.town" label="Ville" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedTir.postalCode" label="Code Postal" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedTir.date" label="Date" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedTir.intensity" label="Intensité" variant="outlined" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="closeTir">Annuler</v-btn>
          <v-btn color="#E65100" variant="flat" rounded="lg" @click="saveTir">Enregistrer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
export default {
  data () {
    return {
      tab: 'articles',
      articles: [],
      errors: [],
      event_types: [],
      following_types: [],
      roles: [],
      users: [],
      followers: [],
      tirs: [],
      dialog: false,
      dialogUser: false,
      dialogFollower: false,
      dialogTir: false,
      headers: [
        { title: 'Titre', key: 'title', align: 'start', sortable: true },
        { title: 'Date', key: 'date', align: 'center', sortable: true },
        { title: 'Type', key: 'eventtype', align: 'center', sortable: true },
        { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
      ],
      headersUsers: [
        { title: 'Identifiant', key: 'UserId', align: 'start', sortable: true },
        { title: 'Prénom', key: 'FirstName', align: 'start', sortable: true },
        { title: 'Nom', key: 'LastName', align: 'start', sortable: true },
        { title: 'Rôle', key: 'Role', align: 'center', sortable: true },
        { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
      ],
      headersFollowers: [
        { title: 'Prénom', key: 'firstname', align: 'start', sortable: true },
        { title: 'Nom', key: 'lastname', align: 'start', sortable: true },
        { title: 'Société', key: 'firm', align: 'start', sortable: true },
        { title: 'Newsletter', key: 'acceptNews', align: 'center', sortable: true },
        { title: 'Type', key: 'followingType', align: 'center', sortable: true },
        { title: 'Fonction', key: 'function', align: 'start', sortable: true },
        { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
      ],
      hearderTirs: [
        { title: 'Nom', key: 'name', align: 'start', sortable: true },
        { title: 'Adresse', key: 'address', align: 'start', sortable: true },
        { title: 'Ville', key: 'town', align: 'start', sortable: true },
        { title: 'Code Postal', key: 'postalCode', align: 'center', sortable: true },
        { title: 'Date', key: 'date', align: 'center', sortable: true },
        { title: 'Intensité', key: 'intensity', align: 'center', sortable: true },
        { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
      ],
      editedItem: {},
      editedUser: {},
      editedTir: {},
      editedFollower: {},
    }
  },
  mounted () {
    this.getEvents()
    this.getUsers()
    this.getEventTypes()
    this.getRoles()
    this.getFollowers()
    this.getFollowingTypes()
    this.getTirs()
  },
  methods: {
    deleteItem (data) {
      const index = this.articles.indexOf(data)
      this.$apiclient.deleteEvent(data.eventid)
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.articles.splice(index, 1)
        })
        .catch(error => {
          if (error.response.status === 401) this.errors.push("Vous n'êtes pas connecté ou non authorisé")
          else this.errors.push(error.response.statusText)
        })
    },
    editItem (item) { this.editedItem = item; this.dialog = true },
    close () { this.dialog = false },
    save () {
      this.$apiclient.modifyEvent(
        this.editedItem.eventid, this.editedItem.date, this.editedItem.title,
        this.editedItem.eventtype, this.editedItem.description,
        this.editedItem.docpath, this.editedItem.picturepath
      )
      this.close()
    },
    editUser (item) { this.editedUser = item; this.dialogUser = true },
    closeUser () { this.dialogUser = false },
    saveUser () {
      this.$apiclient.modifyUser(
        this.editedUser.UserId, this.editedUser.FirstName,
        this.editedUser.LastName, this.editedUser.Role
      )
      this.closeUser()
    },
    deleteUser (data) {
      const index = this.users.indexOf(data)
      this.$apiclient.deleteUser(data.UserId)
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.users.splice(index, 1)
        })
        .catch(error => {
          if (error.response.status === 401) this.errors.push("Vous n'êtes pas connecté ou non authorisé")
          else this.errors.push(error.response.statusText)
        })
    },
    editFollower (item) { this.editedFollower = item; this.dialogFollower = true },
    closeFollower () { this.dialogFollower = false },
    saveFollower () {
      this.$apiclient.modifyFollower(
        this.editedFollower.followerId, this.editedFollower.firstname,
        this.editedFollower.lastname, this.editedFollower.mail,
        this.editedFollower.firm, this.editedFollower.function,
        this.editedFollower.acceptNews, this.editedFollower.followingType
      )
      this.closeFollower()
    },
    deleteFollower (data) {
      const index = this.followers.indexOf(data)
      this.$apiclient.deleteFollower(data.followerId)
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.followers.splice(index, 1)
        })
        .catch(error => {
          if (error.response.status === 401) this.errors.push("Vous n'êtes pas connecté ou non authorisé")
          else this.errors.push(error.response.statusText)
        })
    },
    editTir (item) { this.editedTir = item; this.dialogTir = true },
    closeTir () { this.dialogTir = false },
    saveTir () {
      this.$apiclient.modifyTir(
        this.editedTir.tirId, this.editedTir.name, this.editedTir.address,
        this.editedTir.postalCode, this.editedTir.town,
        this.editedTir.date, this.editedTir.intensity
      )
      this.closeTir()
    },
    deleteTir (data) {
      const index = this.tirs.indexOf(data)
      this.$apiclient.deleteTir(data.tirId)
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.tirs.splice(index, 1)
        })
        .catch(error => {
          if (error.response.status === 401) this.errors.push("Vous n'êtes pas connecté ou non authorisé")
          else this.errors.push(error.response.statusText)
        })
    },
    getEvents () {
      this.$apiclient.getEvents()
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.articles = (response.data != null) ? response.data : []
        })
        .catch(error => {
          if (error.response.status === 401) this.errors.push("Vous n'êtes pas connecté ou non authorisé")
          else this.errors.push(error.response.statusText)
        })
    },
    getUsers () {
      this.$apiclient.getUsers()
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.users = (response.data != null) ? response.data : []
        })
        .catch(error => {
          if (error.response.status === 401) this.errors.push("Vous n'êtes pas connecté ou non authorisé")
          else this.errors.push(error.response.statusText)
        })
    },
    getEventTypes () {
      this.$apiclient.getEventTypes()
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.event_types = (response.data != null) ? response.data : []
        })
        .catch(error => { this.errors.push(error.response.statusText) })
    },
    getRoles () {
      this.$apiclient.getRoles()
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.roles = (response.data != null) ? response.data : []
        })
        .catch(error => { this.errors.push(error.response.statusText) })
    },
    getFollowingTypes () {
      this.$apiclient.getFollowingTypes()
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.following_types = (response.data != null) ? response.data : []
        })
        .catch(error => { this.errors.push(error.response.statusText) })
    },
    getFollowers () {
      this.$apiclient.getFollowers()
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.followers = (response.data != null) ? response.data : []
        })
        .catch(error => {
          if (error.response.status === 401) this.errors.push("Vous n'êtes pas connecté ou non authorisé")
          else this.errors.push(error.response.statusText)
        })
    },
    getTirs () {
      this.$apiclient.getTirs()
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.tirs = (response.data != null) ? response.data : []
        })
        .catch(error => {
          if (error.response.status === 401) this.errors.push("Vous n'êtes pas connecté ou non authorisé")
          else this.errors.push(error.response.statusText)
        })
    },
  }
}
</script>

<style scoped>
.dashboard-page {
  background: #fafafa;
  min-height: 100vh;
}

.page-header {
  padding: 32px 24px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  text-align: center;
}

.page-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #212121;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.page-title-bar {
  width: 40px;
  height: 3px;
  background: #E65100;
  margin: 0 auto 12px;
  border-radius: 2px;
}

.page-subtitle {
  font-size: 0.85rem;
  color: #757575;
  margin: 0;
}

.dashboard-tabs {
  background: #ffffff;
  border-bottom: none;
}

.dashboard-tabs :deep(.v-tab) {
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  min-width: 120px;
}

.dashboard-container {
  max-width: 1200px;
  padding-top: 24px;
  padding-bottom: 48px;
}

.section-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.section-count {
  font-size: 0.78rem;
  color: #9e9e9e;
  font-weight: 600;
  letter-spacing: 0.05em;
}

.data-table {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0,0,0,0.07);
}

.data-table :deep(thead tr th) {
  background: #FFF3E0 !important;
  color: #E65100 !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.08em !important;
  text-transform: uppercase !important;
}

.data-table :deep(tbody tr:hover) {
  background: #fff8f5 !important;
}

.action-icon {
  color: #9e9e9e;
  cursor: pointer;
  transition: color 0.15s;
}

.action-icon:hover {
  color: #E65100;
}

.action-icon.delete:hover {
  color: #c62828;
}

.dialog-header {
  background: #E65100;
  color: white;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  padding: 14px 20px;
  display: flex;
  align-items: center;
}

.gap-2 {
  gap: 8px;
}
</style>
